import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const ResponsiveDropdown = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isMobile) {
    // 📱 On mobile: just a link button
    return (
      <div className="dropdown">
        <Link to="/procedures" className="text-button">
          Services ⌵
        </Link>
      </div>
    );
  }

  // 🖥️ On desktop: link + hover dropdown
  return (
    <div className="dropdown">
      <Link to="/procedures" className="text-button">
        Services ⌵
      </Link>
      <div className="dropdown-content">
        <div className="dropdown-header">Preventative Care</div>
        <Link to="/procedures/exams-and-cleanings">Dental Exams & Cleanings</Link>
        <Link to="/procedures/x-rays">Dental X-Rays</Link>

        <div className="dropdown-header">Restorative Dentistry</div>
        <Link to="/procedures/composite-fillings">Composite Fillings</Link>
        <Link to="/procedures/crowns">Crowns</Link>

        <div className="dropdown-header">Prosthodontics</div>
        <Link to="/procedures/fixed-bridges">Fixed Bridges & Crowns</Link>
        <Link to="/procedures/partial-dentures">Partial Dentures</Link>

        <div className="dropdown-header">Periodontic Health</div>
        <Link to="/procedures/periodontic-diagnosis">Diagnosis</Link>
        <Link to="/procedures/periodontic-treatment">Treatment & Maintenance</Link>

        <div className="dropdown-header">Oral Surgery</div>
        <p>Extractions</p>

        <div className="dropdown-header">Endodontics</div>
        <p>Root Canals Treatment</p>
      </div>
    </div>
  );
};

export default ResponsiveDropdown;

